import { Assert } from '@team/assert';

/**
 * Возвращает `null`, если входное значение не определено или является `null`.
 * В ином случае возвращает преобразованное через `transformer` значение.
 */
export function transformOrNull<T, U>(
  raw: Maybe<Nullable<T>>,
  transformer: (value: T) => U
) {
  if (Assert.isUndefined(raw)) {
    return null;
  }

  if (Assert.isNull(raw)) {
    return null;
  }

  return transformer(raw);
}
